/**
 * FeatureFlagRoute Component
 * Protects routes behind feature flags
 * Can be used standalone or wrapped around ProtectedRoute
 *
 * Usage:
 * <FeatureFlagRoute flag="MESSAGES">
 *   <AdminMessagesPage />
 * </FeatureFlagRoute>
 *
 * Or with ProtectedRoute:
 * <ProtectedRoute>
 *   <FeatureFlagRoute flag="MESSAGES">
 *     <AdminMessagesPage />
 *   </FeatureFlagRoute>
 * </ProtectedRoute>
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Text, Heading } from '@chakra-ui/react';
import { isFeatureEnabled } from '../constants/featureFlags';

const FeatureFlagRoute = ({ flag, children, fallbackPath = '/' }) => {
  if (!isFeatureEnabled(flag)) {
    return (
      <Box
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.50"
        px={4}
      >
        <Box
          textAlign="center"
          p={8}
          bg="white"
          borderRadius="lg"
          boxShadow="md"
          maxW="500px"
        >
          <Heading size="lg" color="red.600" mb={4}>
            Feature Not Available
          </Heading>
          <Text color="gray.600" fontSize="md" mb={6}>
            This feature is not currently enabled. Please contact your administrator if you believe this is an error.
          </Text>
          <Text fontSize="sm" color="gray.500">
            Feature flag: <strong>{flag}</strong>
          </Text>
        </Box>
      </Box>
    );
  }

  return children;
};

export default FeatureFlagRoute;
